module.exports = __webpack_public_path__ + "img/ic-x.7496d3f.svg";